import { render } from "./Title.vue?vue&type=template&id=aa1cf49a&scoped=true"
import script from "./Title.vue?vue&type=script&lang=js"
export * from "./Title.vue?vue&type=script&lang=js"

import "./Title.vue?vue&type=style&index=0&id=aa1cf49a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-aa1cf49a"

export default script